export default __webpack_public_path__ + "static/media/fastingdrink@3x.01764923.jpg";